import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest ,deleteRequest} from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../components/AuthContext';
import { LocaleContext } from '../../components/LocaleContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import UtilContext from '../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { showDeactivatedInLists, showInactiveEmployeesInLists } from '../../utils/moduleSettings';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { normalizeForMatch } from '../../utils/textNormalize';
import { useTrainingCompanies } from '../../utils/useTrainingCompanies';
import {
    computeTrainingSelectionCascade,
    normalizeMachineIds,
    resolveTrainingSelectionDefaults,
    toTrainingSelectionFormValues,
} from '../../utils/trainingSelectionCascade';
import {
    buildEditFormCompanyContactOptions,
    buildEditFormLecturerOptions,
    buildTrainingCardEditFormValues,
    machineIdsKey,
    mergeTrainingCardCascadeFormValues,
} from '../../utils/trainingCardEditHydration';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import {
    emitTrainingCardListRemoved,
    emitTrainingCardListEmployeeSynced,
    trainingCardEmployeeRowFromResponse,
} from '../../utils/trainingCardListSync';
import {
    TRAINING_CARD_SAVE_PATH,
    TRAINING_CARD_UPDATE_PATH_PREFIX,
    buildTrainingCardCreatePayload,
    buildTrainingCardUpdatePayload,
    filterTrng004TrainingOptions,
    interpretTrainingCardSaveResponse,
    interpretTrainingCardSaveTransportError,
    laravelErrorsToFormik,
} from '../../utils/trainingCardSaveHttp';

export default function TrainingCardDetail({ employee, type, navigationContext }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies({ includeExcluded: true });
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const savingCardRef = useRef(false);
    const [savingCard, setSavingCard] = useState(false);

    const [trainingDepartment,setTrainingDepartment] = useState('');
    const [trainings,setTrainings] = useState([]);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({id:true,'training.department.name':true,'training.name':true,initial_date:true,deactivation_date:true,custom_training_status:true,description:true,
        protocol:true,'company.name':true,machines:true,custom_lecturer_name:true,custom_contact_name:true
    });
    const [maskVisible, setMaskVisible] = useState(false);
const [formEmployee, setFormEmployee] = useState(() => (employee?.id ? null : employee));
    const [formType, setFormType] = useState(type);
    const [loadingEmployeeData, setLoadingEmployeeData] = useState(!!employee?.id);

    const displayEmployee = formEmployee ?? employee;

    const reloadCurrentEmployee = () => {
        const id = formEmployee?.id ?? employee?.id;
        if (!id) return Promise.resolve(null);
        setLoadingEmployeeData(true);
        return getRequest(`/api/training_cards/by_employee/${id}`).then((r) => {
            const data = trainingCardEmployeeRowFromResponse(r);
            if (data) setFormEmployee(data);
            return data;
        }).catch(() => null).finally(() => setLoadingEmployeeData(false));
    };

    const syncListAfterEmployeeReload = (closeAfter = false) => {
        const id = formEmployee?.id ?? employee?.id;
        return reloadCurrentEmployee().then((row) => {
            if (row) emitTrainingCardListEmployeeSynced(row);
            else if (id != null) emitTrainingCardListRemoved(id);
            if (closeAfter) dispatch({ type: 'close_tab', id: state.selectedTab });
            return row;
        });
    };

    useEffect(() => {
        if (!employee?.id) return;
        getRequest(`/api/training_cards/by_employee/${employee.id}`)
            .then((resp) => {
                const data = resp?.data ?? resp;
                if (data) setFormEmployee(data);
            })
            .catch(() => {})
            .finally(() => setLoadingEmployeeData(false));
    }, [employee?.id]);

    useEffect(() => {
        if (loadingEmployeeData) {
            const t = ref.current;
            if (t?.initialized) t.alert?.(t('Common.LoadingEllipsis'));
        } else {
            ref.current?.clearAlert?.();
        }
    }, [loadingEmployeeData]);

    const [lecturers, setLecturers] = useState(state.lecturers || []);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [machines, setMachines] = useState(state.machines || []);
    const [loadingDetailData, setLoadingDetailData] = useState(true);

    const [lecturersFallback, setLecturersFallback] = useState([]);
    useEffect(() => {
        setLoadingDetailData(true);
        const hasLecturers = (state.lecturers || []).length > 0;
        Promise.all([
            getRequest("/api/training_types?minimal=1").then((r) => (r?.data ?? r) || []),
            getRequest("/api/company_contacts?minimal=1&module=training").then((r) => {
                const list = r?.data ?? r ?? [];
                return Array.isArray(list) ? list : [];
            }),
            hasLecturers ? Promise.resolve(null) : getRequest("/api/lecturers").then((r) => (r?.data ?? r) || []),
        ])
            .then(([types, contacts, lecturers]) => {
                setTrainingTypesList(types || []);
                setCompanyContactsList(contacts || []);
                if (!hasLecturers && Array.isArray(lecturers)) setLecturersFallback(lecturers);
            })
            .catch(() => {})
            .finally(() => setLoadingDetailData(false));
    }, []);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training"))?false:true);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [visibleCard,setVisibleCard] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    const [activateIcon,setActivateIcon] = useState(true);
    const [deactivateIcon,setDeactivateIcon] = useState(true);
    const [visibleDeactivate, setVisibleDeactivate] = useState(false);

    const [selectedCard,setSelectedCard] = useState(null);
    /** false while opening edit: cascade must not wipe hydrated lecturer/contact/machines */
    const allowEditCascadePruneRef = useRef(false);

    const [showTrainingCardAdd, setShowTrainingCardAdd] = useState(false);
    const [showIntervalCalibration, setShowIntervalCalibration] = useState(false);
    const [visibleFiles,setVisibleFiles] = useState(false);
    const [viewedImage,setViewedImage] = useState('');


    useEffect(() => {
        // Update the document title using the browser API
        if(formEmployee!=null){
            if(user.permissions?.includes("edit training"))setScrollIcons(false);
        }
    },[formEmployee]);

    // Keď je otvorený dialóg Pridať/Upraviť a načíta sa trainingTypesList, znovu naplň dropdown Názov školenia
    useEffect(() => {
        if (!visibleCard && !showTrainingCardAdd) return;
        const owned = (formEmployee?.training_card || []).map(card => card.training_id);
        const training = selectedCard?.training ?? null;
        setTrainings(filterTrng004TrainingOptions(trainingTypesList, {
            departmentId: trainingDepartment,
            ownedIds: owned,
            includeTrainingId: visibleCard ? training?.id : null,
        }));
    }, [visibleCard, showTrainingCardAdd, trainingTypesList, trainingDepartment, formEmployee?.training_card, selectedCard?.training]);

    function addNewTrainingCard(){
        setTrainingDepartment('');
        const owned = (formEmployee?.training_card || []).map(card => card.training_id);
        setTrainings(filterTrng004TrainingOptions(trainingTypesList, { ownedIds: owned }));
        setSelectedCard(null);
        setShowTrainingCardAdd(true);
    }

    function editNewTrainingCard(){
        const row = ref.current.getSelectedData()[0];
        if (!row) return;
        allowEditCascadePruneRef.current = false;
        setSelectedCard(row);
        startFormikUpdate(row);
        formikUpdate.setValues(buildTrainingCardEditFormValues(row));
        const rowDeptId = row.training?.department_id ?? row.training?.department?.id;
        filterTrainings(rowDeptId ?? '', row.training);
        setTimeout(() => setVisibleCard(true), 0);
    }

    function hideEditCard(){
        allowEditCascadePruneRef.current = false;
        formikUpdate.resetForm();
        setVisibleCard(false);
    }

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        setDeactivateIcon(true);
        setActivateIcon(true);
        if(ref.current.getSelectedData().length === 1){
            if(user.permissions?.includes("edit training"))setEditIcon(false);
            if(user.permissions?.includes("delete training"))setDeleteIcon(false);
            if(user.permissions?.includes("add training")){
                if(ref.current.getSelectedData()[0]._children.length==0)setDeleteIcon(false);
                if(ref.current.getSelectedData()[0].deactivation_date=="" || ref.current.getSelectedData()[0].deactivation_date==null)setDeactivateIcon(false);
                else setActivateIcon(false);
            }
            setSelectedCard(ref.current.getSelectedData()[0]);
        }
        else{
            var deactivated = 0;
            var activated = 0;
            ref.current.getSelectedData().forEach(item => {
                if(item.deactivation_date=="" || item.deactivation_date==null)activated++;
                else deactivated++;
            });
            if(!deactivated && activated)setDeactivateIcon(false);
            else if(deactivated && !activated)setActivateIcon(false);
        }
    }

    const validate = values => {
        const errors = {};
        if (values?.machines?.length<1) {
            errors.machines = t('Common.RequiredField');
        }
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const notifyTrainingCardSave = (severity, messageKey, detail) => {
        const summary = t(messageKey);
        const text = detail || summary;
        if (toast?.current?.show) {
            toast.current.show({ severity, summary, life: 4000, detail: text });
            return;
        }
        alert(text);
    };

    const formik = useFormik({
        initialValues:{
           training_id:'',initial_date:'',deactivation_date:'',description:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            if (savingCardRef.current) return;
            savingCardRef.current = true;
            setSavingCard(true);
            const payload = buildTrainingCardCreatePayload(values, employee?.id);
            postRequest(TRAINING_CARD_SAVE_PATH, payload)
            .then((response) => {
                const result = interpretTrainingCardSaveResponse(response);
                if (!result.ok) {
                    formik.setErrors({ ...formik.errors, ...laravelErrorsToFormik(result.fieldErrors) });
                    notifyTrainingCardSave('error', result.messageKey, result.detail ? result.detail : t(result.messageKey));
                    return;
                }
                formik.resetForm();
                setShowTrainingCardAdd(false);
                notifyTrainingCardSave('info', result.messageKey);
                syncListAfterEmployeeReload(closeTab);
            }).catch(() => {
                const result = interpretTrainingCardSaveTransportError(navigator.onLine);
                notifyTrainingCardSave('error', result.messageKey, t(result.messageKey));
            }).finally(() => {
                savingCardRef.current = false;
                setSavingCard(false);
            });
        },
    });

    const formikUpdate = useFormik({
        initialValues: selectedCard ? {
            id: selectedCard?.id,training_id:selectedCard?.training_id,initial_date:selectedCard?.initial_date,deactivation_date:selectedCard?.deactivation_date,
            description:selectedCard?.description,company_id:selectedCard?.company_id || selectedCard?.training?.training_company_id,
            machines:selectedCard?.machines.map((machine) => ({name:machine.name,id:machine.id})),
            lecturer_id:selectedCard?.lecturer_id || selectedCard?.company_contact?.lecturer_id,company_contact_id:selectedCard?.company_contact_id} : 
            {training_id:'',initial_date:'',deactivation_date:'',description:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            if (savingCardRef.current) return;
            savingCardRef.current = true;
            setSavingCard(true);
            const payload = buildTrainingCardUpdatePayload(values, employee?.id);
            postRequest(`${TRAINING_CARD_UPDATE_PATH_PREFIX}${formikUpdate.values.id}`, payload)
            .then((response) => {
                const result = interpretTrainingCardSaveResponse(response);
                if (!result.ok) {
                    formikUpdate.setErrors({ ...formikUpdate.errors, ...laravelErrorsToFormik(result.fieldErrors) });
                    notifyTrainingCardSave('error', result.messageKey, result.detail ? result.detail : t(result.messageKey));
                    return;
                }
                setVisibleCard(false);
                formikUpdate.resetForm();
                notifyTrainingCardSave('info', result.messageKey);
                syncListAfterEmployeeReload(closeTab);
            }).catch(() => {
                const result = interpretTrainingCardSaveTransportError(navigator.onLine);
                notifyTrainingCardSave('error', result.messageKey, t(result.messageKey));
            }).finally(() => {
                savingCardRef.current = false;
                setSavingCard(false);
            });
        },
    });

    const formikDeactivation = useFormik({
        initialValues:{
           deactivation_date:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let rows_to_activate = [];
            rows_to_activate = ref.current.getSelectedData();
            let formData = new FormData();
            rows_to_activate.forEach((item) => {
                formData.append("cards[]",item.id);
            })
            formData.append("deactivation_date",values.deactivation_date);
            postRequest(`/api/training_cards/deactivate`, formData,true)
            .then((response) => {
                setVisibleDeactivate(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsUpdatedDetail') });
                syncListAfterEmployeeReload(false);
            }).catch((reason) => {
                setVisibleDeactivate(false);
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordUpdateFailedDetail'), life: 3000 });
            });
        },
    });

    const showDeactivated = showDeactivatedInLists(state.module_settings, 'training');
    const showInactiveEmployees = showInactiveEmployeesInLists(state.module_settings);
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const show = showDeactivated ? '1' : '0';
                const showInactive = showInactiveEmployees ? '1' : '0';
                const url = `/api/training_cards/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}&show_deactivated=${show}&show_inactive_employees=${showInactive}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null) {
            const toParams = () => {
                const p = new URLSearchParams();
                (navigationContext.filters || []).forEach(f => {
                    if (f.value != null && String(f.value).trim() !== '') p.set(`filter_${f.field}`, f.value);
                });
                if (navigationContext.sorters?.length) p.set('sorters', JSON.stringify(navigationContext.sorters));
                return p.toString();
            };
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), setFormEmployee, () => formEmployee?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), setFormEmployee, () => formEmployee?.id);
    }, [navigationContext, formEmployee?.id, showDeactivated, showInactiveEmployees, setDialogText, setVisible]);

    function filterTrainings(departmentId, training = null){
        setTrainingDepartment(departmentId);
        const owned = (formEmployee?.training_card || []).map(card => card.training_id);
        setTrainings(filterTrng004TrainingOptions(trainingTypesList, {
            departmentId,
            ownedIds: owned,
            includeTrainingId: training?.id,
        }));
    }

      function InitialDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.initial_date ? DateTime.fromISO(rowData.initial_date).toFormat(dateFmt) : "";
      }

      function DeactivationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.deactivation_date ? DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt) : t('Common.ActivePlural');
      }

      function onEditRow(training_card){
        allowEditCascadePruneRef.current = false;
        setSelectedCard(training_card);
        startFormikUpdate(training_card);
        formikUpdate.setValues(buildTrainingCardEditFormValues(training_card));
        const cardDeptId = training_card.training?.department_id ?? training_card.training?.department?.id;
        filterTrainings(cardDeptId ?? '', training_card.training);
        setTimeout(() => setVisibleCard(true), 0);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const acceptActivate = () => {
        let rows_to_activate = [];
        rows_to_activate = ref.current.getSelectedData();
        let formData = new FormData();
        rows_to_activate.forEach((item) => {
            formData.append("cards[]",item.id);
        })
        postRequest(`/api/training_cards/activate`, formData,true)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsUpdatedDetail') });
            syncListAfterEmployeeReload(false);
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordUpdateFailedDetail'), life: 3000 });
        });
    }

    const confirmActivate = () => {
        confirmDialog({
            message: t('TrainingCardDetail.Text.Prajete_si_tieto_skolenia_aktivovat'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptActivate
        });
    };

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/training_cards/${element.id}`)
          .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
            syncListAfterEmployeeReload(false);
          }).catch((reason) => {
              alert(reason);
              toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 }); 
          })
        }); 
      }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecords'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            rejectClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            defaultFocus: 'accept',
            reject: accept,
            accept: reject
        });
    };
      
    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(filterParams.name=="initial_date"){
            if(rowValue=="")return false;
            return DateTime.fromISO(rowData.initial_date).toFormat(dateFmt).includes(headerValue);
        }
        if(filterParams.name=="deactivation_date"){
            if(headerValue== "Deaktivované"){
                return !!(rowData.deactivation_date && rowData.deactivation_date!="");
            }
            if(headerValue== "Aktívne" || (headerValue && t('Common.ActivePlural').toLocaleLowerCase().normalize('NFD').includes(String(headerValue).normalize('NFD').toLocaleLowerCase()))){
                return rowData.deactivation_date=="" || rowData.deactivation_date==null;
            }
            if(rowValue=="")return false;
            return DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt).includes(headerValue);
        }
        return false;
    }

    function deactivationDateOnlyHeaderFilter(headerValue, rowValue, rowData) {
        if(!headerValue || String(headerValue).trim()==="")return true;
        if(!rowData.deactivation_date)return false;
        return DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt).includes(headerValue);
    }

    function TrainingStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <span>{rowData?.deactivation_date ? t('Common.Deactivated') : t('Common.ActivePlural')}</span>;
    }

    function trainingStatusHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        return selected.length > 0 && selected.includes(rowData.custom_training_status);
    }

    function departmentHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        const deptName = String(rowData.training?.department?.name ?? rowValue ?? '').trim();
        if (!deptName) return false;
        const norm = normalizeForMatch(deptName);
        return selected.length > 0 && selected.some(s => normalizeForMatch(s) === norm);
    }

    function trainingNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(rowData.training?.name ?? rowValue ?? '').trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function companyNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(rowData.company?.name ?? rowValue ?? '').trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function LecturerName(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.lecturer_id) return rowData?.lecturer?.name;
        else return rowData?.company_contact?.lecturer?.name;
    }

    function ContactName(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.company_contact?.employee_id) return rowData?.company_contact?.employee?.name;
        else return rowData?.company_contact?.name;
    }

    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        console.log(rowData);
        if(rowData?._children?.length > 0){   
            if(rowData?._children[0]?.files)return <div className='flex flex-row'>{rowData?._children[0]?.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>
        }
        return "";
    }

    function machineHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const arr = rowData.machines;
        if (!arr || !Array.isArray(arr) || arr.length === 0) return false;
        const names = arr.map(m => m?.name).filter(Boolean).join(' ');
        return normalizeForMatch(names).includes(normalizeForMatch(headerValue));
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(
            rowData?.lecturer?.name ?? rowData?.company_contact?.lecturer?.name ?? rowValue ?? ''
        ).trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function contactHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(
            rowData?.company_contact?.employee?.name ?? rowData?.company_contact?.name ?? rowValue ?? ''
        ).trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function MachineFormatter(props){
        const rowData = props.cell.getRow().getData();
        const arr = rowData.machines;
        if (!arr || !Array.isArray(arr)) return '';
        return arr.map(machine => machine?.name).filter(Boolean).join('/');
    }

    const departments = state.departments || [];
    const departmentsKey = departments.length ? departments.map(d => d.id).join(',') : '';
    const columns = useMemo(() => [
        { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, minWidth: 44, headerSort: false, resizable: false, frozen: true, print: false },
        { hozAlign:"center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false, frozen: true, print: false },
        { title: 'ID', field: 'id', width: 70, minWidth: 70, headerFilter: "input", frozen: false },
        { title: t('Common.TrainingDepartment'), field: 'training.department.name', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: departments.map(d => ({ label: d.name, value: d.name })), placeholder: t('Common.TrainingDepartment') }, headerFilterFunc: departmentHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: t('Common.TrainingName'), field: 'training.name', headerFilter: "input", headerFilterFunc: trainingNameHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: t('TrainingCardDetail.Text.Prvotne_skolenie'), field: 'initial_date', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<InitialDate/>), headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: "initial_date" } },
        { title: t('Common.Deactivation'), field: 'deactivation_date', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<DeactivationDate/>), headerFilterFunc: deactivationDateOnlyHeaderFilter },
        { title: t('Common.TrainingStatus'), field: 'custom_training_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: t('Common.ActivePlural'), value: "Aktívne" }, { label: t('Common.Deactivated'), value: "Deaktivované" }], placeholder: t('Common.TrainingStatus') }, headerFilterFunc: trainingStatusHeaderFilter, formatter: reactFormatter(<TrainingStatusFormatter/>), minWidth: 200, widthGrow: 1 },
        { title: t('Common.Description'), field: 'description', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: 'Protokol', field: 'protocol', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<Protocol/>) },
        { title: t('Common.TrainingCompanyShort'), field: 'company.name', headerFilter: "input", headerFilterFunc: companyNameHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: 'Stroj', field: 'machines', headerFilter: "input", headerFilterFunc: machineHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<MachineFormatter/>) },
        { title: 'Lektor', field: 'custom_lecturer_name', headerFilter: "input", headerFilterFunc: lecturerHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<LecturerName/>) },
        { title: t('Common.Trainer'), field: 'custom_contact_name', headerFilter: "input", headerFilterFunc: contactHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<ContactName/>) },
    ], [departmentsKey]);

    useEffect(() => {
        ref.current?.setColumns?.(columns);
    }, [columns]);

    const tableData = useMemo(
        () => (formEmployee?.training_card ?? []).map(card => ({ ...card, custom_training_status: card.deactivation_date ? t('Common.Deactivated') : t('Common.ActivePlural') })),
        [formEmployee?.training_card]
    );

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
       console.log(columnVisible);
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            ref.current.hideColumn(`${val}`);
          }
          else{
            ref.current.showColumn(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            ref.current.redraw(true);
          }, 0)
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const defaultColumnsVisible = {id:true,'training.department.name':true,'training.name':true,initial_date:true,deactivation_date:true,custom_training_status:true,description:true,protocol:true,'company.name':true,machines:true,custom_lecturer_name:true,custom_contact_name:true};
    const resetMask = () => resetTabulatorMask({ page: 'TrainingCardDetail', defaultColumnsVisible, ref, columns, setColumnsVisible });
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("TrainingCardDetail","set_filters",null,ref.current.getHeaderFilters(),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("TrainingCardDetail","set_filters",null,[],null);ref.current.clearHeaderFilter();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("TrainingCardDetail","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("TrainingCardDetail","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingCardDetail');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="specific_id" || columnVisible[val]!=="editor" || columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=value;
              ref.current.showColumn(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
          setTimeout(() => {
            ref.current.redraw(true);
          }, 0)
      }

      function cardCascadeSnapshot(overrides) {
        const current = visibleCard ? formikUpdate : formik;
        const training = overrides.selectedTraining
          ?? (trainingTypesList || []).find((t) => t.id == (overrides.training_id ?? current.values?.training_id))
          ?? null;
        return {
            companies: trainingCompanies,
            machines: state.machines || [],
            lecturerTypes: (state.lecturers || []).length ? (state.lecturers || []) : (lecturersFallback || []),
            companyContacts: companyContactsList || [],
            allowedMachineIds: normalizeMachineIds(training?.machines),
            constrainToSelectedContact: true,
            ...overrides,
        };
      }

      function applyCardCascade(targetFormik, snapshot) {
        const result = computeTrainingSelectionCascade(cardCascadeSnapshot(snapshot));
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
        const preserveHydrated = Boolean(visibleCard && !allowEditCascadePruneRef.current);
        const cascaded = mergeTrainingCardCascadeFormValues(
            targetFormik.values,
            toTrainingSelectionFormValues(result),
            { preserveHydrated },
        );
        targetFormik.setValues({
            ...targetFormik.values,
            ...cascaded,
            ...(snapshot.training_id != null ? { training_id: snapshot.training_id } : {}),
        });
      }

      function changeTraining(training_id){
        const current = visibleCard ? formikUpdate : formik;
        if (visibleCard) allowEditCascadePruneRef.current = true;
        const training = (trainingTypesList || []).find((t) => t.id == training_id);
        const defaults = resolveTrainingSelectionDefaults(training, {
            companyId: current.values?.company_id,
            machineIds: current.values?.machines,
        });
        applyCardCascade(current, {
            selectedTraining: training,
            training_id,
            companyId: defaults.companyId,
            machineIds: defaults.machineIds,
            lecturerTypeId: current.values?.lecturer_id,
            companyContactId: current.values?.company_contact_id,
            allowedMachineIds: normalizeMachineIds(training?.machines),
        });
      }

      function changeCompany(company_id){
        const current = visibleCard ? formikUpdate : formik;
        if (visibleCard) allowEditCascadePruneRef.current = true;
        applyCardCascade(current, {
            companyId: company_id,
            machineIds: current.values?.machines,
            lecturerTypeId: current.values?.lecturer_id,
            companyContactId: current.values?.company_contact_id,
        });
      }

      function changeMachine(nextMachines){
        const current = visibleCard ? formikUpdate : formik;
        if (visibleCard) {
            const nextKey = machineIdsKey(nextMachines);
            const curKey = machineIdsKey(current.values?.machines);
            // Ignore transient empty MultiSelect emissions while options remount during open.
            if (nextKey !== '' && nextKey !== curKey) {
                allowEditCascadePruneRef.current = true;
            }
        }
        applyCardCascade(current, {
            companyId: current.values?.company_id,
            machineIds: nextMachines,
            lecturerTypeId: current.values?.lecturer_id,
            companyContactId: current.values?.company_contact_id,
        });
      }

      function changeLecturer(lecturer_id){
        const current = visibleCard ? formikUpdate : formik;
        if (visibleCard) allowEditCascadePruneRef.current = true;
        applyCardCascade(current, {
            companyId: current.values?.company_id,
            machineIds: current.values?.machines,
            lecturerTypeId: lecturer_id,
            companyContactId: current.values?.company_contact_id,
        });
      }

      function startFormikUpdate(selectedCard){
        const training = selectedCard?.training
          || (trainingTypesList || []).find((t) => t.id == selectedCard?.training_id)
          || null;
        const result = computeTrainingSelectionCascade(cardCascadeSnapshot({
            selectedTraining: training,
            companyId: selectedCard?.company_id ?? selectedCard?.company?.id ?? selectedCard?.training?.training_company_id,
            machineIds: selectedCard?.machines,
            lecturerTypeId: selectedCard?.lecturer_id ?? selectedCard?.company_contact?.lecturer_id ?? selectedCard?.lecturer?.id,
            companyContactId: selectedCard?.company_contact_id ?? selectedCard?.company_contact?.id,
            allowedMachineIds: normalizeMachineIds(training?.machines),
        }));
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
    }

    function viewFile(file_id){
        getRequest(`/api/training_records/protocol/${file_id}`).then((response) => {
            console.log(response);
            setVisibleFiles(true);
            setViewedImage(response.data);
        });
    }

    const machineBaseOptions = useMemo(() => (machines || []).map(m => ({ id: m.id, name: m.name })), [machines]);

    // Odvodené možnosti pre edit dialóg – vždy zahŕňajú lektora/školiteľa z riadku
    // aj keď cascade runtime listy sú dočasne prázdne.
    const editFormLecturers = useMemo(() => {
        if (!visibleCard || !selectedCard) return lecturers;
        const fullLecturers = (state.lecturers || []).length ? (state.lecturers || []) : (lecturersFallback || []);
        return buildEditFormLecturerOptions({
            cascadeLecturers: lecturers,
            companyContactsList,
            fullLecturers,
            selectedCard,
        });
    }, [visibleCard, selectedCard, companyContactsList, state.lecturers, lecturersFallback, lecturers]);

    const editFormCompanyContacts = useMemo(() => {
        if (!visibleCard || !selectedCard) return companyContacts;
        return buildEditFormCompanyContactOptions({
            cascadeContacts: companyContacts,
            companyContactsList,
            selectedCard,
        });
    }, [visibleCard, selectedCard, companyContactsList, companyContacts]);

    const machineSelectOptionsUpdate = useMemo(() => {
        const base = machineBaseOptions;
        const sel = formikUpdate.values?.machines || [];
        const missing = sel.filter(s => !base.some(b => b.id == (s?.id ?? s)));
        return [...base, ...missing.map(m => ({ id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }))];
    }, [machineBaseOptions, formikUpdate.values?.machines]);

    const machineSelectValueUpdate = useMemo(() => {
        const opts = machineSelectOptionsUpdate;
        const sel = formikUpdate.values?.machines || [];
        const byId = (arr, id) => arr.find(x => (x?.id ?? x) == id);
        return sel.map(m => byId(opts, m?.id ?? m) || { id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }).filter(Boolean);
    }, [machineSelectOptionsUpdate, formikUpdate.values?.machines]);

    const machineSelectOptions = useMemo(() => {
        const base = machineBaseOptions;
        const sel = formik.values?.machines || [];
        const missing = sel.filter(s => !base.some(b => b.id == (s?.id ?? s)));
        return [...base, ...missing.map(m => ({ id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }))];
    }, [machineBaseOptions, formik.values?.machines]);

    const machineSelectValue = useMemo(() => {
        const opts = machineSelectOptions;
        const sel = formik.values?.machines || [];
        const byId = (arr, id) => arr.find(x => (x?.id ?? x) == id);
        return sel.map(m => byId(opts, m?.id ?? m) || { id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }).filter(Boolean);
    }, [machineSelectOptions, formik.values?.machines]);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingCard()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewTrainingCard()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="activate"><button className="disabled:opacity-25" disabled={activateIcon} onClick={confirmActivate}><ActivateIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="deactivate"><button className="disabled:opacity-25" disabled={deactivateIcon} onClick={() => setVisibleDeactivate(true)}><DeactivateIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => reloadCurrentEmployee()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Util.Tab.EditGaugeCalibration'),"TrainingCardDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("TrainingCardDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        {loadingDetailData ? (
        <div className="flex flex-col items-center justify-center h-[calc(100vh-177px)] bg-gray-100 gap-4">
            <InfinitySpin width="120" color="#333" />
            <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
        </div>
        ) : (
        <>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={10}>
        <form onSubmit={formik.handleSubmit} className='w-full'>
        <div className="relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   KARTA ZAMESTNANCA
                </h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {displayEmployee?.id}</label>
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Meno zamestnanca
                        </label>
                        <input
                            name='name'
                            type="text"
                            readOnly value={displayEmployee?.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="defined_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('CustomerAdd.Label.DefinedId')}</label>
                        <input
                            name='defined_id'
                            type="number"
                            readOnly value={displayEmployee?.defined_id}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                </div>  
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div>
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                      <div>
                        <label
                            htmlFor="date_of_entry"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeList.Column.DateOfEntry')}</label>
                        <input
                            name='date_of_entry'
                            type="text"
                            readonly value={displayEmployee?.date_of_entry ? DateTime.fromISO(displayEmployee?.date_of_entry).toFormat(dateFmt) : ""}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="date_of_departure"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeList.Column.DateOfDeparture')}</label>
                        <input
                            name='date_of_departure'
                            type="text"
                            readonly value={displayEmployee?.date_of_departure ? DateTime.fromISO(displayEmployee?.date_of_departure).toFormat(dateFmt) : ""}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                        <div>
                        <label
                            htmlFor="department_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Department')}</label>
                        <select 
                        name='department_id'
                        disabled value={displayEmployee?.department_id}
                        className='block w-full h-[42px] px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeAdd.Label.Description')}</label>
                        <input
                            name='description'
                            type="text"
                            readOnly value={displayEmployee?.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                </div>  
            </div>
            </div> 
            </div>
             </form>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      data={tableData}
      onRef={(r) => (ref.current = r.current)}
      className='h-full w-full' //176px h-[calc(100vh_-_176px)]
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        renderComplete: () => {
            if(ref.current?.getSelectedData()?.length === 0){
              setEditIcon(true);
              setCopyIcon(true);
              setDeleteIcon(true);
              setActivateIcon(true);
              setDeactivateIcon(true);
            }
          },
        tableBuilt: () => {
            if (loadingEmployeeData) ref.current?.alert?.(t('Common.LoadingEllipsis'));
            let mask = (state.user_mask_filters || []).filter(mask => mask.page=="TrainingCardDetail");
            const safeParse = (v, fallback) => {
                if (v === null || v === undefined) return fallback;
                if (typeof v === "string") {
                try { return JSON.parse(v); } catch { return fallback; }
                }
                return v; // už je array/object
            };
            if (mask.length > 0) {
                const attributes  = safeParse(mask[0].attributes, []);
                const filters     = safeParse(mask[0].filters, []);
                const sorters     = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                    ref.current.setColumnLayout(attributes);
                }
                if (Array.isArray(filters)) {
                    filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
                }
                if (Array.isArray(sorters) && sorters.length > 0) {
                    ref.current.setSort(sorters);
                }
                if (json_columns && typeof json_columns === "object") {
                    setColumnsVisible(json_columns);
                    for (let column in json_columns) {
                        if (json_columns[column] === false) ref.current.hideColumn(column);
                        else ref.current.showColumn(column);
                    }
                }
            }
          },
          columnMoved: () => { setUserMaskFilter("TrainingCardDetail", "column_move", null, null, ref.current.getColumnLayout()); },
          columnResized: () => { setUserMaskFilter("TrainingCardDetail", "column_resized", null, null, ref.current.getColumnLayout()); },
      }}
      options={{renderHorizontal:"virtual",layout:"fitColumns",movableColumns:true,resizableColumnFit:true,
      dataLoader: true,
      dataLoaderLoading: t('Common.LoadingData'),
      dataLoaderError: t('Common.LoadFailed'),
      printAsHtml:true,printRowRange:"active",
      /*groupBy:"training.department.name",
      groupHeader:function(value, count, data, group){
        //value - the value all members of this group share
        //count - the number of rows in this group
        //data - an array of all the row data objects in this group
        //group - the group component for the group
            if(value=="----------")return "Všeobecné <span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
            return value + "<span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
      },*/
      printHeader:function(){
        const bodyHtml = ReactDOMServer.renderToStaticMarkup(<div>
          <div className="mt-6">
              <div className="md:grid grid-cols-2 gap-1 mb-2">
                <div className='mb-2'>
                  <label
                      htmlFor="name"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >
                      Meno zamestnanca
                  </label>
                  <input
                      name='name'
                      type="text"
                      value={formEmployee?.name}
                      style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                      className="border rounded-md"
                  />
                  </div>
                  <div className='mb-2'>
                  <label
                      htmlFor="defined_id"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >{t('CustomerAdd.Label.DefinedId')}</label>
                  <input
                      name='defined_id'
                      type="number"
                      value={formEmployee?.defined_id}
                      style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                      className="border rounded-md"                  />
                  </div>
                  <div>
                  <label
                      htmlFor="department_id"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >{t('Common.Department')}</label>
                  <select 
                  name='department_id'
                  value={formEmployee?.department_id}
                  style={{fontSize: '1rem',width:'100%',height:'42px',padding:'4px 4px 4px 4px',}}
                   className="border rounded-md">
                    <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                    {(state.departments || []).map((department) => (
                      <option key={department.id} value={department.id}>{department.name}</option>
                    ))}
                  </select>
                  </div>
              </div>
          </div>
          <div className="mt-6">
              <div className="md:grid grid-cols-2 gap-4 mb-2">
                <div className='mb-2'>
                  <label
                      htmlFor="date_of_entry"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >{t('EmployeeList.Column.DateOfEntry')}</label>
                  <input
                      name='date_of_entry'
                      type="text"
                      value={formEmployee?.date_of_entry ? DateTime.fromISO(formEmployee?.date_of_entry).toFormat(dateFmt) : ""}
                      style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                      className="border rounded-md"
                  />
                  </div>
                  <div>
                  <label
                      htmlFor="date_of_departure"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >{t('EmployeeList.Column.DateOfDeparture')}</label>
                  <input
                      name='date_of_departure'
                      type="text"
                      value={formEmployee?.date_of_departure ? DateTime.fromISO(formEmployee?.date_of_departure).toFormat(dateFmt) : ""}
                      style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                      className="border rounded-md"                  />
                  </div>
              </div>
              <div className="md:grid grid-cols-2 gap-4 mb-2">
                  <div>
                  <label
                      htmlFor="description"
                      className="block text-left text-lg font-semibold text-gray-800"
                  >{t('EmployeeAdd.Label.Description')}</label>
                  <input
                      name='description'
                      type="text"
                      readOnly value={formEmployee?.description}
                      style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                      className="border rounded-md"
                  />
                  </div>
              </div>
          </div>
          </div>);
        return buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.TrainingCardDetail'),
          printDateLabel: t('Print.DateLabel'),
          bodyHtml,
        });
      },
      printFooter: function () {
        return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
      },
    }}/>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('TrainingCardDetail.Text.Upravit_v_karte_zamestnanca')} visible={visibleCard} style={{ width: '40vw' }} onHide={() => hideEditCard()}>
    <form onSubmit={formikUpdate.handleSubmit}>
                        <div>
                            <label
                                htmlFor="trainingDepartment"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingDepartment')}</label>
                            <select 
                            required
                            name='trainingDepartment'
                            onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                            className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                            {(state.departments || []).map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="training_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            {t('Common.TrainingName')}
                            </label>
                            <select required
                            name='training_id'
                            onChange={(e) => changeTraining(e.target.value)} value={formikUpdate.values?.training_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                            {trainings.map((training) => (
                                <option key={training.id} value={training.id}>{training.name}</option>
                            ))}
                            </select>
                        </div>   
                        <div>
                            <label
                                htmlFor="initial_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_prvotneho_skolenia')}</label>
                            <input
                                name='initial_date'
                                type="date"
                                required
                                onChange={formikUpdate.handleChange} value={formikUpdate.values?.initial_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="training_status"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingStatus')}</label>
                            <select
                                name='training_status'
                                value={formikUpdate.values?.deactivation_date ? t('Common.Deactivated') : t('Common.ActivePlural')}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    formikUpdate.setFieldValue('deactivation_date', v === "Aktívne" ? '' : formikUpdate.values?.deactivation_date || '');
                                }}
                                className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            >
                                <option value="Aktívne">{t('Common.ActivePlural')}</option>
                                <option value="Deaktivované">{t('Common.Deactivated')}</option>
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="deactivation_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_deaktivacie')}</label>
                            <input
                                name='deactivation_date'
                                type="date"
                                onChange={formikUpdate.handleChange} value={formikUpdate.values?.deactivation_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label
                                htmlFor="company_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingCompanyShort')}</label>
                            <select required
                            name='company_id'
                            onChange={(e) => changeCompany(e.target.value)} value={formikUpdate.values?.company_id}
                            disabled={loadingCompanies}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                            {trainingCompanies.map((training_company) => (
                                <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                            ))}
                            </select>
                        </div> 
                        {(formikUpdate.values?.company_id!="" && formikUpdate.values?.company_id!=null) && <><div>
                            <label
                                htmlFor="machines"
                                className="block text-md font-semibold text-gray-800"
                            >
                                Stroj*
                            </label>
                            <MultiSelect value={machineSelectValueUpdate} onChange={(e) => changeMachine(e.value)}
                                options={machineSelectOptionsUpdate}
                                optionLabel="name"
                                dataKey="id"
                                filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            {formikUpdate.errors?.machines ? <span style={{color: "red"}}>{formikUpdate.errors?.machines}</span> : ""} 
                        </div>
                        {(formikUpdate.values?.machines?.length > 0) && <><div>
                            <label
                                htmlFor="lecturer_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Lektor
                            </label>
                            <select required
                            name='lecturer_id'
                            onChange={(e) => changeLecturer(e.target.value)} value={formikUpdate.values?.lecturer_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                            {(editFormLecturers || lecturers).map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formikUpdate.values?.lecturer_id!="" && formikUpdate.values?.lecturer_id!=null) && <div>
                            <label
                                htmlFor="company_contact_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.Trainer')}</label>
                            <select
                            name='company_contact_id'
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.company_contact_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                            {(editFormCompanyContacts || companyContacts).map((contact) => (
                                <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                            ))}
                            </select>
                        </div>}</>}</>}
                        <button type="submit" disabled={savingCard} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
            </form>
      </Dialog>
        <Dialog header={t('TrainingCardDetail.Text.Pridat_do_karty_zamestnanca')} visible={showTrainingCardAdd} style={{ width: '40vw' }} onHide={() => setShowTrainingCardAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
                        <div>
                            <label
                                htmlFor="trainingDepartment"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingDepartment')}</label>
                            <select 
                            required
                            name='trainingDepartment'
                            onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                            className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                            {(state.departments || []).map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="training_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            {t('Common.TrainingName')}
                            </label>
                            <select required
                            name='training_id'
                            onChange={(e) => changeTraining(e.target.value)} value={formik.values.training_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                            {trainings.map((training) => (
                                <option key={training.id} value={training.id}>{training.name}</option>
                            ))}
                            </select>
                        </div>   
                        <div>
                            <label
                                htmlFor="initial_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_prvotneho_skolenia')}</label>
                            <input
                                name='initial_date'
                                type="date"
                                required
                                onChange={formik.handleChange} value={formik.values.initial_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="training_status_add"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingStatus')}</label>
                            <select
                                name='training_status_add'
                                value={formik.values.deactivation_date ? t('Common.Deactivated') : t('Common.ActivePlural')}
                                onChange={(e) => {
                                    formik.setFieldValue('deactivation_date', e.target.value === "Aktívne" ? '' : formik.values.deactivation_date || '');
                                }}
                                className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            >
                                <option value="Aktívne">{t('Common.ActivePlural')}</option>
                                <option value="Deaktivované">{t('Common.Deactivated')}</option>
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="deactivation_date_add"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_deaktivacie')}</label>
                            <input
                                name='deactivation_date'
                                type="date"
                                onChange={formik.handleChange} value={formik.values.deactivation_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label
                                htmlFor="company_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TrainingCompanyShort')}</label>
                            <select required
                            name='company_id'
                            onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                            disabled={loadingCompanies}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                            {trainingCompanies.map((training_company) => (
                                <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                            ))}
                            </select>
                        </div> 
                        {(formik.values?.company_id!="" && formik.values?.company_id!=null) && <><div>
                            <label
                                htmlFor="machines"
                                className="block text-md font-semibold text-gray-800"
                            >
                                Stroj*
                            </label>
                            <MultiSelect value={machineSelectValue} onChange={(e) => changeMachine(e.value)}
                                options={machineSelectOptions}
                                optionLabel="name"
                                dataKey="id"
                                filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""} 
                        </div>
                        {(formik.values?.machines?.length > 0) && <><div>
                            <label
                                htmlFor="lecturer_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Lektor
                            </label>
                            <select required
                            name='lecturer_id'
                            onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                            {lecturers.map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formik.values?.lecturer_id!="" && formik.values?.lecturer_id!=null) && <div>
                            <label
                                htmlFor="company_contact_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.Trainer')}</label>
                            <select
                            name='company_contact_id'
                            onChange={formik.handleChange} value={formik.values?.company_contact_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                            {companyContacts.map((contact) => (
                                <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                            ))}
                            </select>
                        </div>}</>}</>}
                        <button type="submit" disabled={savingCard} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
            </form>
            </Dialog>
            <Dialog header={t('Common.PdfPreview')} visible={visibleFiles} onHide={() => setVisibleFiles(false)} style={{ width: '80vw',height:'90vh',backgroundColor: 'transparent',boxShadow: 'none'}}>
                    <iframe src={viewedImage.url} className='w-full h-full'></iframe>
                    </Dialog>
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2 || index==9) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingCardDetail","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
          <Dialog header={t('Common.Deactivation')} visible={visibleDeactivate} style={{ width: '40vw' }} onHide={() => setVisibleDeactivate(false)}>
            <form onSubmit={formikDeactivation.handleSubmit}>
              <div className="flex flex-columns justify-between">
                <label>
                  Dátum:
                <input
                    value={formikDeactivation.values.deactivation_date} onChange={formikDeactivation.handleChange}
                    name='deactivation_date'
                    type="date" required
                    className="block w-full px-1 py-1 mr-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                /> 
                </label>
                <button type='submit' className='w-fit ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.VYKONAT')}</button>
              </div>
              </form>
            </Dialog>
        </>
        )}
            </div>
            </> 
            );
} 
